<template>
  <ul class="c-icon-list">
    <li class="c-icon-list__item" v-for="item in items" :key="item.index">
      <button class="c-icon-list__link" @click="handleClick(item.title)">
        <span class="c-icon-list__icon" v-if="item.icon">
          <svg class="c-icon-list__icon-svg" aria-hidden="true" focusable="false">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="`#${item.icon}`"></use></svg>
        </span>
        <span class="c-icon-list__label">{{ item.title }}</span>
      </button>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      items: {
        required: true,
        type: Object,
      }
    },
    methods:{
      handleClick(title) {
        this.$emit('click', title);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/contact-us/_vue/IconList.vue